import translate from './translate';

export default function(item) {
  return translate(item.x || 0, item.y || 0);
}


//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/util/svg/translateItem.js
// module id = 280
// module chunks = 0